import React from "react";
import { Quote } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { HERO_IMG } from "../../lib/site";

export default function Story() {
  return (
    <Section id="story" bg="bg-white">
      <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16 items-start">
        {/* Left image */}
        <Reveal>
          <div className="lg:sticky lg:top-24">
            <div className="rounded-[30px] border-2 border-brand-black overflow-hidden shadow-[10px_12px_0_#E90019] bg-brand-red">
              <img src={HERO_IMG} alt="Ratish Jha" loading="lazy" className="w-full object-cover aspect-[4/5]" />
            </div>
            <div className="mt-4 rounded-2xl border-2 border-brand-black bg-brand-yellow px-5 py-3 text-center">
              <p className="font-display text-lg">Ratish Jha</p>
              <p className="text-xs font-semibold text-brand-ink/70">Fewer than 3,000 subscribers · ₹14L+ earned</p>
            </div>
          </div>
        </Reveal>

        {/* Right story */}
        <Reveal delay={0.1}>
          <Eyebrow color="#E90019">The Story</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.02] mt-5">
            I Have Fewer Than 3,000 Subscribers. And That Is Exactly Why My Story Matters.
          </h2>

          <div className="mt-6 space-y-4 text-base sm:text-lg text-brand-ink/80 leading-relaxed font-serif-e">
            <p><span className="float-left font-display text-6xl leading-[0.7] mr-3 mt-1 text-brand-blue">H</span>i, I am Ratish Jha. I have spent years working with YouTube, testing strategies, making mistakes, learning from failures, and trying to answer one important question:</p>
            <p className="font-bold text-brand-black not-italic">How can someone use YouTube to build a real business—not just collect views?</p>
            <p>Over time, I stopped chasing vanity metrics and started focusing on something more valuable: <span className="text-brand-blue font-semibold">the right viewer, with the right problem, watching the right video, at the right time.</span></p>
            <p>In the last year, I have earned more than <span className="font-bold text-brand-black not-italic">₹14 lakh</span>, with YouTube at the core of my customer acquisition system—even though my channel has fewer than 3,000 subscribers.</p>
          </div>

          <p className="text-xs text-brand-ink/50 mt-4">This is Ratish&rsquo;s personal experience and is not an income guarantee.</p>

          {/* Pull quote */}
          <div className="mt-8 rounded-[26px] border-2 border-brand-black bg-brand-black text-brand-cream p-7 sm:p-9 relative"
            style={{ boxShadow: "10px 12px 0 #4CAF48" }}>
            <Quote className="text-brand-green mb-3" size={30} />
            <p className="font-display text-2xl sm:text-3xl leading-tight">
              You do not necessarily need millions of views to build a meaningful business through YouTube.
            </p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
